import React,
{
    useEffect,
    useState,
    useRef
}
from 'react';
import RGLIcon from './RGLIcon';

const DEFAULT_CENTRAL_SIZE = 140;
const DEFAULT_CORNER_SIZE = 96;
const LOADER_FADE_MS = 360;

const FRAME_CONFIG = {
    loading: {
        framePrefix: 'LoadingLeo',
        loop: true,
    },
    finished: {
        framePrefix: 'LoadedLeo',
        loop: false,
    },
};

export default function LeoLoadingShit(
{
    visible,
    mode = 'loading',
    position = 'bottom-left',
    showText = false,
    onFinished,
})
{
    const [internalVisible, setInternalVisible] = useState(visible);
    const [fadeOut, setFadeOut] = useState(false);
    const [sequenceKey, setSequenceKey] = useState(0);
    const timeoutRef = useRef(null);
    const previousModeRef = useRef(mode);
    const previousVisibleRef = useRef(visible);

    useEffect(() =>
    {
        if (visible && !previousVisibleRef.current)
        {
            setInternalVisible(true);
            setFadeOut(false);
        }
        else if (!visible && previousVisibleRef.current)
        {
            setFadeOut(true);
            timeoutRef.current = setTimeout(() =>
            {
                setInternalVisible(false);
                setFadeOut(false);
            }, LOADER_FADE_MS);
        }

        previousVisibleRef.current = visible;

        return () =>
        {
            if (timeoutRef.current)
            {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
    }, [visible]);

    useEffect(() =>
    {
        if (mode !== previousModeRef.current)
        {
            previousModeRef.current = mode;
            setFadeOut(false);
            setSequenceKey((value) => value + 1);
            if (mode === 'finished')
            {
                setInternalVisible(true);
            }
        }
    }, [mode]);

    const handleSequenceComplete = () =>
    {
        if (mode !== 'finished') return;
        setFadeOut(true);
        timeoutRef.current = setTimeout(() =>
        {
            setInternalVisible(false);
            setFadeOut(false);
            if (typeof onFinished === 'function')
            {
                onFinished();
            }
        }, LOADER_FADE_MS);
    };

    if (!internalVisible) return null;

    const config = FRAME_CONFIG[mode] || FRAME_CONFIG.loading;
    const isCentered = position === 'center';
    const wrapperStyle = {
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: isCentered ? 'center' : 'flex-end',
        justifyContent: isCentered ? 'center' : 'flex-start',
        padding: 20,
        pointerEvents: 'none',
        zIndex: 11000,
        opacity: fadeOut ? 0 : 1,
        transition: `opacity ${LOADER_FADE_MS}ms ease`,
    };

    const panelStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8,
        pointerEvents: 'none',
        background: isCentered ? 'rgba(0, 0, 0, 0.64)' : 'transparent',
        padding: isCentered ? '18px 20px' : 0,
        borderRadius: isCentered ? 18 : 0,
        minWidth: isCentered ? 220 : 'auto',
    };

    return ( <div style = { wrapperStyle } >
        <div style = { panelStyle } >
        <RGLIcon
        key = { sequenceKey }
        basePath = "/LeoLoadingShit"
        size = { isCentered ? DEFAULT_CENTRAL_SIZE : DEFAULT_CORNER_SIZE }
        fps = { 24 }
        framePrefix = { config.framePrefix }
        loop = { config.loop }
        onSequenceComplete = { handleSequenceComplete }
        />
        </div>
        </div>
    );
}
